
const dataSlider = [
  {
    ide: 1,
    title: "Bienvenida",
    subTitle: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
    background: "img1.jpg",
    image: "bienvenida.svg"
  },
  {
    ide: 2,
    title: "Propuesta de valor",
    subTitle: "Lorem ipsum dolor sit amet, consectetur elit. Donec fermentum, tellus ac molestie.",
    background: "img2.jpg",
    image: "valor.svg"
  },
  {
    ide: 3,
    title: "¡Tú ganas!",
    subTitle: "Vulputate, ante leo fermentum nulla, sit amet ornare lorem eros a massa, leo fermentum.",
    background: "img3.jpg",
    image: "ganas.svg"
  },
  {
    ide: 4,
    title: "...y de Regalo!",
    subTitle: "Lorem ipsum dolor sit amet, adipiscing elit. Donec fermentum, tellus ac molestie.",
    background: "img1.jpg",
    image: "empecemos.svg"
  }
];

export default dataSlider;